  <template>
    <div>
      <div
        class="d-flex flex-column flex-md-row title align-md-center"
        v-if="!isCreate"
      >
        <div>Job Number: #{{ item.job_number }}</div>
        <v-spacer></v-spacer>
        <tech-upload-images :uploads="this.item.uploads || []"></tech-upload-images>
        <div class="subtitle-1 d-flex mt-2 mb-2">
          SMS Status :
          <span :style="style" class="ml-2"> {{ smsLabel }}</span>
        </div>
      </div>
      <v-row
        :class="$root.isMobile ? 'mt-4' : 'mt-2'"
        class="no-col-padding"
        :no-gutters="$root.isMobile"
      >
        <v-col class="d-flex" cols="12" :sm="4">
          <v-autocomplete
            outlined
            label="Job Type"
            :dense="$root.dense"
            item-text="name"
            item-value="id"
            :rules="rules"
            @change="onInput"
            :items="jobTemplates"
            v-model="form.template"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" :sm="4">
          <v-autocomplete
            outlined
            label="Technicians"
            :dense="$root.dense"
            item-text="name"
            item-value="phone"
            @change="onTechnicianChange"
            clearable
            :items="list"
            v-model="form.technician"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" :sm="4">
          <div class="d-flex">
            <v-checkbox
              class="pt-0 mt-2"
              @change="onInput"
              v-model="form.is_scheduled"
              :disabled="isScheduleDisabled"
              hide-details=""
            ></v-checkbox>
            <date-time-picker
              @change="onInput"
              class="flex-1"
              :disabled="!form.is_scheduled || isScheduleDisabled"
              :rules="form.is_scheduled ? dispositionRules : []"
              v-model="form.scheduled_at"
              ref="apt"
              :endAt="form.schedule_end_at"
              @onEndSelect="form.schedule_end_at = $event"
              label="Appointment"
            ></date-time-picker>
          </div>
        </v-col>
        <v-col cols="12" sm="4" class="d-flex">
          <date-picker
            label="Job Created Date"
            @input="onInput"
            :max="max"
            v-model="form.created_at"
            :outlined="true"
          ></date-picker>
          <div class="pa-1"></div>
          <date-picker
            label="Disposition Date"
            @input="onInput"
            :max="max"
            :rules="[]"
            :disabled="!item.disposition"
            v-model="form.disposition_date"
            :outlined="true"
          ></date-picker>
        </v-col>
        <v-col cols="12" :sm="4">
          <v-select
            label="Select Disposition"
            :disabled="!item.disposition"
            :dense="$root.dense"
            :items="dispositions"
            v-model="form.disposition"
            item-text="name"
            item-value="id"
            @change="onInput"
            outlined
          >
          </v-select>
        </v-col>
        <v-col cols="12" :sm="4" v-if="reasonItem && isCancelled">
          <v-select
            :label="reasonItem.name"
            :dense="$root.dense"
            :items="reasonItem.options"
            v-model="form.reason"
            item-text="name"
            @change="onInput"
            outlined
          >
          </v-select>
        </v-col>

        <v-col cols="12" :sm="4">
          <v-select
            label="Job Status"
            :disabled="!isJob"
            :dense="$root.dense"
            :items="jobTypes"
            v-model="form.status"
            item-text="name"
            item-value="value"
            @change="onInput"
            outlined
          >
          </v-select>
        </v-col>
        <v-col cols="12" :sm="4">
          <v-autocomplete
            label="Dispatcher"
            :dense="$root.dense"
            :items="users"
            :rules="rules"
            v-model="form.dispatcher"
            item-text="name"
            item-value="email"
            @change="onInput"
            outlined
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" :sm="4" v-if="isAutoJob">
          <v-text-field
            label="VIN Number"
            :dense="$root.dense"
            class="address_input"
            v-model="form.vin_number"
            @change="onInput"
            outlined
          >
            <template v-slot:append-outer>
              <v-btn
                depressed
                class="primary"
                @click="decodeVin()"
                tile
                :width="is_mobile ? '' : '120px'"
                color="white"
                :height="$root.dense ? '40px' : '56px'"
                >Decode VIN</v-btn
              >
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12" :sm="4">
          <v-text-field
            label="Technician Actual Collected"
            :dense="$root.dense"
            class="address_input"
            v-model="form.technician_total_collected"
            @change="onInput"
            outlined
          >
          </v-text-field>
        </v-col>

      </v-row>
      <div class="d-flex pa-4 px-2 gap-4">
    <v-text class="title">Total Flat Rate Price ($): {{ total || 0 }}</v-text>
    
    <v-row class="d-flex align-center ml-4" dense>
      <v-col cols="12" :sm="2">
        <v-btn-toggle
          v-model="payment"
          class="toggle-group"
          mandatory
          @change="changePaymentType"
          color="green"
        >
          <v-btn :value="'cash'" color="white" depressed tile small>{{ paymentOptions[0].name }}</v-btn>
          <v-btn :value="'credit_card'" color="white" depressed tile small>{{ paymentOptions[1].name }}</v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-row>
     
    </v-row>
    
  </div>
      <v-alert v-model="alert" dismissible color="primary" dense outlined>
        <div v-html="vinDetails"></div>
      </v-alert>
      <v-divider></v-divider>
      <technician-zone-info
        @onTechnicianClick="form.technician = $event"
        ref="zone"
      ></technician-zone-info>
    </div>
  </template>

  <script>
  import smsList from "../../../assets/js/sms_status";
  import smsColor from "../../../assets/js/sms_color";
  import { status } from "../../../assets/js/default";
  import DatePicker from "../../DatePicker.vue";
  import { FIELD } from "../../../assets/js/rules";
  import customerMixins from "../../../assets/js/customer.mixins";
  import DateTimePicker from "../../DateTimeRangePicker.vue";
  import {
    formatMessage,
    formatPhone,
    getDateOnly,
  } from "../../../assets/js/common";
  import { auth } from "../../../assets/js/firebase";
  import axios from "axios";
  import TechUploadImages from "./TechUploadImages.vue";
  import TechnicianZoneInfo from "./TechnicianZoneInfo.vue";
  import customerModal from "../../../assets/js/customer.modal";
  import { EventBus } from "../../../main";
  export default {
    components: {
      DatePicker,
      DateTimePicker,
      TechUploadImages,
      TechnicianZoneInfo,
    },
    props: {
      value: {
        type: Object,
        default: () => {
          return {};
        },
      },
      isAutoJob: {
        type: Boolean,
        default: false,
      },
      item: {
        type: Object,
        default: () => {
          return {};
        },
      },
      total: [String, Number],
    },
    mixins: [customerMixins],
    data() {
      return {
        
        type: null,
        vinDetails: "",
        alert: false,
        paymentOptions: [
          { value: "cash", name: "Cash" },
          { value: "credit_card", name: "Credit/Debit" },
        ],
        payment : "credit_card",
        form: {
          template: "",
          technician: "",
          is_scheduled: false,
          scheduled_at: "",
          disposition: "",
          created_at: "",
          status: "",
          dispatcher: "",
          schedule_end_at: "",
          disposition_date: "",
          vin_number: "",
          technician_total_collected: "",
          reason: "",
        },
        max: getDateOnly(),
        dispositionRules: FIELD,
        rules: [(v) => !!v || "Response type is required."],
      };
    },
    computed: {
      
      isCancelled() {
        return this.form.disposition == customerModal.DISPOSITION_CANCEL;
      },
      zipcodes() {
        let items = this.$store.getters.zipcodes.map((item) => {
          let { zipcode, community, zone } = item;
          let doc = {};
          doc.value = item.id;
          doc.name = `${zipcode} / ${community} / ${zone}`;
          return doc;
        });
        
        return items;
      },
      jobTypes() {
        return status.filter((item) => {
          return item.value != -1;
        });
      },
      isScheduleDisabled() {
        let { status } = this.item;
        // if (this.isCreate) return false;
        return status == 7;
      },
      users() {
        let users = this.$store.getters.users;
        return [...users].map((i) => ({
          ...i,
          email: i.email.toLowerCase().trim(),
        }));
      },
      dispositions() {
        return this.$store.getters.dispositions;
      },
      list() {
        return this.$store.getters.technicians;
      },
      smsLabel() {
        return smsList[this.item.sms];
      },
      style() {
        return { color: smsColor[this.item.sms] };
      },
      reasonItem() {
        let item = [...this.$store.getters.globalFields].find(
          (i) => i.id == customerModal.REASON_FOR_CANCELLATION
        );
        return item;
      },
    },
    methods: {
      async decodeVin() {
        const vm = this;
        let vin = vm.form.vin_number;
        if (!vin) return vm.$alert.show("Please enter VIN Number");
        try {
          vm.$loader.show();
          let url = `https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVin/${vin}?format=json`;
          let data = (await axios.get(url)).data;
          let items = [27, 39, 26, 28, 29, 5, 75, 37];
          let message = "";
          items.forEach((key) => {
            let item = data.Results.find((i) => i.VariableId == key);
            if (item) {
              message += `<b>${item.Variable}:</b> ${item.Value}<br/>`;
            }
          });
          vm.vinDetails = message;
          vm.alert = true;
          vm.$loader.hide();
        } catch (error) {
          vm.$alert.show(error);
          vm.$loader.hide();
        }
      },
      onInput() {
        this.$emit("input", this.form);
        
      },
      // setUploads(files){
      //   this.items?.uploads = [files];
      // }
      openAPT() {
        this.form.is_scheduled = true;
        this.$refs.apt.dialog = true;
      },
      onTechnicianChange() {
        const vm = this;
        let technician = this.list.find((i) => i.id == this.form.technician);
        if (technician && technician.zones) {

          EventBus.$emit("technician-selected", technician);
          vm.$store.dispatch('reRenderOutsideTechnician', technician);
          let fields = {};
          this.list.forEach((i) => {
            fields[i.id] = `${i.name} ${formatPhone(i.phone)}`;
          });
          let msg = formatMessage({
            message: technician.message || "",
            fields,
            isTech: true,
            options: {},
          });
          let message = `<div style="outline:none" contenteditable="plaintext-only">${msg}</div>
          Following zones are assigned to this technician:
          <br/>
          `;
          message += technician.zones
            .toString()
            .split(",")
            .join("<br/>");
          vm.$refs.zone.init(message);
          // vm.$alert.show(message, "Zone Message");
        }else if(technician){
          EventBus.$emit("technician-selected", technician);
        }
        vm.onInput();
      },
      resetForm() {  // reseting job detail's specific field values
        this.form = {
          ...this.form,
          template: "",
          technician: "",
          technician_total_collected: ""
        }
      },
      getFilesFromChild(uploadsData) {
        console.log('second component file');
        this.form.uploads = [...uploadsData];
        console.log("this.upladss", this.form.uploads);
        EventBus.$emit("getFiles", uploadsData);
      },
      changePaymentType() {
        EventBus.$emit("changePaymentType", this.payment);
      },
      changePaymentToggle(data) {
        if(data.toLowerCase() == 'cash'){
          this.payment = 'cash';
        } else {
          this.payment = 'credit_card';
        }
      } 
  
     
    },
    mounted() {
      EventBus.$on('emptyJobDetails', this.resetForm);
      EventBus.$on('getFilesFromChild', this.getFilesFromChild);
      EventBus.$on('changePaymentToggle', this.changePaymentToggle);
    },
    beforeMount() {
      const vm = this;
      vm.form = vm.value;
      if (vm.isCreate) {
        vm.form.dispatcher = auth.currentUser.email;
      }
    },
  };
  </script>

  <style lang="scss">
  .customer-input {
    max-width: 400px;
  }
  </style>
